import { type JSX, useState } from "react";

import { SelectionFilter } from "common/components/Filter/index";
import SearchInput from "common/components/SearchInput";
import useDebounce from "common/hooks/useDebounce";

import type { Icon } from "@phosphor-icons/react";

// a SelectionFilter wrapper that provides a search input
export default function SearchInputFilter({
  label,
  renderTagsComponent,
  children,
  // this optional component is rendered above the input field
  renderExtraComponent = null,
  icon = null,
}: {
  label: string;
  renderTagsComponent: (resetInputValue: () => void) => JSX.Element;
  children: (query: string, resetInputValue: () => void) => JSX.Element;
  renderExtraComponent?: (resetInputValue: () => void) => JSX.Element;
  icon?: Icon;
}) {
  const [inputValue, setInputValue] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useDebounce(inputValue, 300);

  function resetInputValue() {
    setDebouncedQuery("");
    setInputValue("");
  }

  return (
    <SelectionFilter
      label={label}
      icon={icon}
      tagsComponent={renderTagsComponent(resetInputValue)}
    >
      {renderExtraComponent?.(resetInputValue)}
      <SearchInput
        variant="sm"
        value={inputValue}
        onClear={() => setInputValue("")}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={`Search ${label.toLowerCase()}`}
      />
      {children(debouncedQuery, resetInputValue)}
    </SelectionFilter>
  );
}
